import { AssetDetails, CustomerDetails } from './api';

export type EditableFieldKey =
    | 'phone'
    | 'email'
    | 'address'
    | 'pincode'
    | 'rto_code'
    | 'charger_number';

export const isFieldBlank = (value?: string): boolean =>
    !value || !value.trim().length;

export const validateField = (
    field: EditableFieldKey,
    value: string
): string => {
    const trimmedValue = value?.trim() || '';

    switch (field) {
        case 'phone':
            return /^[6-9]\d{9}$/i.test(trimmedValue)
                ? ''
                : 'Please enter valid mobile number';
        case 'email':
            if (!trimmedValue) return '';
            return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                trimmedValue
            )
                ? ''
                : 'Please enter valid email';
        case 'address':
            return trimmedValue.length >= 4 ? '' : 'Please enter valid address';
        case 'pincode':
            return /^[1-9][0-9]{5}$/i.test(trimmedValue)
                ? ''
                : 'Please enter valid pincode';
        case 'rto_code':
            return /^[A-Za-z]{2}[0-9]{2}$/i.test(trimmedValue)
                ? ''
                : 'Please enter valid rto';
        case 'charger_number':
            return '';
        default:
            return '';
    }
};

export const validateEditableFields = (
    customerDetails: CustomerDetails,
    vehicleDetails: AssetDetails
): Record<EditableFieldKey, string> => ({
    phone: validateField('phone', customerDetails.phone),
    email: validateField('email', customerDetails.email),
    address: validateField('address', customerDetails.address),
    pincode: validateField('pincode', customerDetails.pincode),
    rto_code: validateField('rto_code', vehicleDetails.rto_code),
    charger_number: validateField(
        'charger_number',
        vehicleDetails.charger_number
    ),
});

export const areRequiredEditableFieldsComplete = (
    customerDetails: CustomerDetails,
    vehicleDetails: AssetDetails
): boolean =>
    ![
        customerDetails.phone,
        customerDetails.address,
        customerDetails.pincode,
        vehicleDetails.rto_code,
    ].some(isFieldBlank);

export const hasEditableFieldErrors = (
    errors: Record<EditableFieldKey, string>
): boolean => Object.values(errors).some((error) => error.length > 0);
